import { Star, ShieldCheck, Clock, MapPin, Award } from "lucide-react";

export default function TrustBadges() {
  const items = [
    { icon: Award, label: "11 Years in Business", testid: "badge-years" },
    { icon: Star, label: "4.9 Google Rating", testid: "badge-rating" },
    { icon: ShieldCheck, label: "Most Tickets Reduced", testid: "badge-reduced" },
    { icon: Clock, label: "Open Daily 8 AM – 10 PM", testid: "badge-hours" },
    { icon: MapPin, label: "Serving Western Canada", testid: "badge-area" },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 sm:gap-4">
      {items.map((it) => (
        <div
          key={it.label}
          data-testid={it.testid}
          className="flex items-center gap-3 bg-white border border-slate-200 rounded-lg p-4 shadow-sm"
        >
          <it.icon className={`w-7 h-7 text-gold flex-shrink-0 ${it.icon === Star ? 'fill-gold' : ''}`} strokeWidth={2.5} />
          <span className="font-semibold text-black text-base leading-tight">{it.label}</span>
        </div>
      ))}
    </div>
  );
}
